import { render, staticRenderFns } from "./scheduleNotification.vue?vue&type=template&id=982e4568&"
import script from "./scheduleNotification.vue?vue&type=script&lang=js&"
export * from "./scheduleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports